// Página PÚBLICA (sin auth): Google Play exige una URL de política de privacidad
// para la app móvil GyleLogistic. El texto fuente vive en
// packages/mobile/store-assets/PRIVACY_POLICY.md — mantener ambos en sintonía.
export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="mx-auto max-w-3xl rounded-xl bg-white p-8 shadow-sm">
        <div className="mb-8 flex items-center gap-4">
          <img src="/logotrack.png" alt="GyleLogistic" className="h-14 w-14" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Política de Privacidad — GyleLogistic
            </h1>
            <p className="text-sm text-gray-500">Última actualización: 31 de julio de 2026</p>
          </div>
        </div>

        <div className="space-y-6 text-[15px] leading-relaxed text-gray-700">
          <p>
            GyleLogistic es una aplicación de uso interno operada por{' '}
            <strong>Inversiones Pérez Taveras</strong> ("la Empresa") para el rastreo GPS de
            vehículos y la gestión de préstamos vehiculares. Esta política describe qué datos
            trata la aplicación móvil y con qué fin.
          </p>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">1. Quién es responsable</h2>
            <p>
              Inversiones Pérez Taveras, República Dominicana. Contacto:{' '}
              <a
                href="mailto:soporte@inversionespereztaveras.com"
                className="font-medium text-blue-700 hover:underline"
              >
                soporte@inversionespereztaveras.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">2. Datos que recopilamos</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>
                <strong>Datos de cuenta:</strong> correo electrónico y contraseña (la contraseña
                viaja cifrada y se almacena con hash en nuestros servidores; en el teléfono los
                tokens de sesión se guardan en el almacenamiento seguro del sistema).
              </li>
              <li>
                <strong>Fotos de evidencia:</strong> los agentes de recuperación pueden tomar o
                adjuntar fotos del vehículo durante un proceso de incautación. Estas fotos se
                suben a nuestros servidores y forman parte del expediente del proceso.
              </li>
              <li>
                <strong>Teléfonos de referencia y notas</strong> que el agente registre como
                parte de la evidencia.
              </li>
              <li>
                <strong>Datos del negocio</strong> (vehículos, posiciones GPS de los dispositivos
                instalados en los vehículos, préstamos, cuotas y pagos): estos datos provienen de
                los sistemas de la Empresa y se muestran en la app; no se generan en tu teléfono.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">3. Ubicación del teléfono</h2>
            <p>
              La app solicita el permiso de ubicación únicamente para centrar el mapa y facilitar
              la navegación hacia el vehículo.{' '}
              <strong>
                La ubicación de tu teléfono no se envía a nuestros servidores ni se comparte con
                terceros.
              </strong>{' '}
              Las posiciones que ves en el mapa corresponden al dispositivo GPS instalado en el
              vehículo, no a tu teléfono.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">4. Cámara y galería</h2>
            <p>
              Los permisos de cámara y galería se usan exclusivamente para capturar o adjuntar
              fotos de evidencia cuando el usuario lo decide. La app no accede a tus fotos en
              segundo plano.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">
              5. Con quién compartimos datos
            </h2>
            <p>
              No vendemos ni compartimos datos personales con terceros. La app utiliza Google
              Maps para mostrar mapas; al renderizar el mapa, Google puede recibir datos técnicos
              conforme a su propia{' '}
              <a
                href="https://policies.google.com/privacy"
                className="font-medium text-blue-700 hover:underline"
                rel="noreferrer"
              >
                política de privacidad
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">6. Seguridad y retención</h2>
            <p>
              Toda la comunicación con nuestros servidores viaja cifrada (HTTPS/TLS). Los datos
              se conservan mientras exista la relación contractual o lo exija la ley dominicana;
              las posiciones GPS históricas se depuran automáticamente según la política de
              retención configurada por la Empresa.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">7. Tus derechos</h2>
            <p>
              Puedes solicitar acceso, corrección o eliminación de tus datos personales
              escribiendo a{' '}
              <a
                href="mailto:soporte@inversionespereztaveras.com"
                className="font-medium text-blue-700 hover:underline"
              >
                soporte@inversionespereztaveras.com
              </a>
              . Atenderemos la solicitud en un plazo razonable conforme a la Ley 172-13 de
              protección de datos de la República Dominicana.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">8. Menores</h2>
            <p>
              La aplicación es de uso empresarial y no está dirigida a menores de 18 años.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-gray-900">
              9. Cambios a esta política
            </h2>
            <p>
              Publicaremos cualquier cambio en esta misma URL, actualizando la fecha del
              encabezado.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
